export const aiExplainantionStates = {
  "personal-loan-calculator": [
    "loanAmount",
    "timePeriod",
    "intrestRate",
    "totalAmount",
  ],
  "fixed-deposit-calculator": [
    "investmentAmmount",
    "noOfFDYear",
    "incrementPerYear",
    "sumAmount",
  ],
  "recurring-deposit-calculator": [
    "investmentAmmount",
    "timePeriod",
    "intrestRate",
    "totalAmount",
  ],
  "debt-to-income-ratio-calculator": [
    "monthlyIncome",
    "creditPay",
    "carPay",
    "studentPay",
    "dtiRatio",
    "totalMonthlyDebt",
    "remainingIncome",
  ],
  "net-worth-calculator": [
    "sharesEquity",
    "incomeAssets",
    "cashAccounts",
    "estateValue",
    "goldJewelry",
    "otherAssets",
    "homeLoans",
    "otherLoans",
    "incomeTaxLonas",
    "billsPayments",
    "creditCardDues",
    "otherLiabilities",
    "netWorth",
    "totalAssets",
    "totalLiabilities",
  ],
  "loan-payoff-calculator": [
    "loanAmount",
    "timePeriod",
    "intrestRate",
    "prePayment",
    "newEmi",
    "timeUnit",
    "totalAmount",
    "remainingPrinciple",
  ],
  "student-education-loan-calculator": [
    "loanAmmount",
    "timePeriod",
    "intrestRate",
    "emi",
    "totalAmount",
  ],
  "credit-card-payoff-calculator": [
    "loanAmmount",
    "intrestRate",
    "monthlyPay",
    "monthsToPayoff",
    "totalAmount",
  ],
  "business-loan-calculator": [
    "loanAmmount",
    "timePeriod",
    "intrestRate",
    "bussinessEmi",
    "totalAmount",
  ],
  "salary-calculator": [
    "hourlyWage",
    "hoursPerWeek",
    "offDaysPerWeek",
    "annualSalary",
  ],
  "pension-calculator": [
    "currentAge",
    "retirementAge",
    "contributionYears",
    "monthlyContribution",
    "annualIncrease",
    "expectedReturn",
    "annuityInvestment",
    "annuityRate",
    "pensionErrors",
    "monthlyPension",
    "calculationResults",
  ],
    "car-lease-calculator": [
    "downPayment",
    "months",
    "monthlyPayment",
    "securityDeposit",
    "purchasePrice",
    "interestRate",
    "carResult",
    "calculationResults",
  ],
    "mortgage-loan-refinance-calculator": [
      "mortgageAmount",
    "intrestRate",
    "loanTerm",
    "newLoanTerm",
    "newIntrestRate",
    "mortgagePoints",
    "refinancingCost",
    "cashOut",
    "startDate",
    "newStartDate",
    "mortageErrors",
    "newAmount",
    "calculationResults",
  ],
  "401k-retirement-calculator": [
    "annualSalary",
    "estimatedReturn",
    "monthlyContribution",
    "currentAge",
    "retirementAge",
    "returnRate",
    "currentBalance",
    "employerMatch",
    "salaryLimit",
    "monthsToRetirement",
    "calculationResults",
  ],
    "saving-goal-calculator": [
    "savingGoalAmount",
    "existingInvestment",
    "expectedInflation",
    "expectedReturn",
    "timePeriod",
    "monthlyInvestment",
    "futureValueOfGoal",
    "futureValueOfExistingInvestment",
  ],
  "loan-to-value-calculator": [
    "propertyValue",
    "timePeriod",
    "interestRate",
    "propertyType",
    "employmentType",
    "monthlyEmi",
    "calculationResults",
  ],
  "gst-tax-calculator": [
    "principle",
    "gstAmount",
    "totalAmount",
  ],
    "sip-investment-calculator": [
    "age",
    "monthlyInvestment",
    "incrementPerYear",
    "approxReturn",
    "noOfInvestementYear",
    "swpStartYear",
    "yearlyWithdraw",
    "yearlyIncrementInWithdrawSwp",
    "resultSip",
  ],
};
